import React from 'react';
import { Link } from 'react-router-dom';
import styles from './NotFound.module.css';

const NotFound = () => (
  <div className={styles.wrap}>
    <h1 className={styles.title}>404</h1>
    <p className={styles.text}>Страница не найдена</p>
    <Link to="/" className={styles.link}>На главную</Link>
  </div>
);

export default NotFound;
